import { EDataSyncLevel, EDataSyncScope, EDataSyncTypes, RelationLink } from "../../../@types";

export enum EventListenerCodes {
  UNKNOWN = "UNKNOWN",
  ERROR = "ERROR",
  TIME_OUT = "TIME_OUT",
  TRANSACTION_OK = "000",
  INTERNAL_SERVER_ERROR = "001",
}

export interface IEventListenerQueryResult {
  event?: ICachedEventData;
}

export interface ICachedEventData {
  action: ICachedEventAction;
  status: EventListenerCodes;
}

export interface ICachedEventAction {
  covid: string;
  guid: string;
  links: RelationLink;
  type: string; //TODO: define type enums as in app_backend (POST/PUT/UPSERT)
  scope: EDataSyncScope;
}

export interface IStartEventListenerInput {
  level: EDataSyncLevel;
  accountId: string;
  transactionId: string;
  scope?: EDataSyncScope;
  type?: EDataSyncTypes;
}
